import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Separator from '../components/Separator';
import FeaturedSolutions, { FeaturedItem } from '../components/FeaturedSolutions';
import tabletInfoGenesis from '../assets/products/tablet-info-genesis.png';
import appOndemandFood from '../assets/products/app-ondemand-food.png';
import appQrQuickpay from '../assets/products/app-qr-quickpay.png';

const LoungePage = () => {
  const navigate = useNavigate();

  return (
    <div className="page loungePage">
      <Header />
      <div className="page-header">Golf Course</div>

      <div className="text-wrapper">
        <div className="top">
          <div className="topic-header">Club & Lounge</div>
          <Separator />
        </div>
        <div className="std-text">
          {"Deliver comfortable, efficient club & lounge experiences. With member information at their fingertips, servers know food preferences, allergies, personal celebrations and more.\n\n"}
        </div>
        <div className="std-text">
          {"Ensure that transactions apply member account rules, pricing and family benefits, and that accounts are charged appropriately."}
        </div>
      </div>

      <FeaturedSolutions>
        <FeaturedItem
          label="InfoGenesis"
          imgSrc={tabletInfoGenesis}
          onClick={() => navigate('/solutions/info-genesis')}
        />
        <FeaturedItem
          label="IG OnDemand"
          imgSrc={appOndemandFood}
          onClick={() => navigate('/solutions/ig-on-demand')}
        />
        <FeaturedItem
          label="IG Quick Pay"
          imgSrc={appQrQuickpay}
          onClick={() => navigate('/solutions/ig-quick-pay')}
        />
      </FeaturedSolutions>
    </div>
  );
};

export default LoungePage;
